export enum ViewPermissions {
  ViewHomepage = 'VIEW_HOMEPAGE',
  ViewDashboard = 'VIEW_DASHBOARD',
  ViewConfiguration = 'VIEW_CONFIGURATION',
  ViewCdn = 'VIEW_CDN',
  ViewProfileSetings = 'VIEW_PROFILE_SETTING',
  ViewWorkspace = 'VIEW_WORKSPACE',
}
